import Backbone from 'backbone';

var ViewableMixin = {
    reportView: function(entity, eventID, options) {
        options = options || {};

        if (!eventID || !this.id) {
            options.error && options.error();
            return;
        }

        var success = options.success;
        options.success = function() {
            success && success();
        };

        var error = options.error;
        options.error = function(data) {
            var errorCode = data['error-code'] || 0;
            error && error(errorCode);
        };

        const now = Date.now();
        const data = {
            userActivities: [{
                activity: 'view',
                entityType: entity,
                entityId: this.id,
                context: 'web',
                eventId: eventID,
                activityTimestamp: now,
                visible: true
            }]
        };

        Backbone.ajax({
            url: `/api/v2/userProfile/activities?eventId=${eventID}`,
            method: 'POST',
            data: data,
            success: options.success,
            error: options.error
        });
    }
};

export default ViewableMixin;

